import { useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslate } from 'react-admin';
// Utils
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  CircularProgress,
  Box,
  InputLabel,
  Select,
  MenuItem,
  FormControl
} from '@material-ui/core';

import { termsContentES, termsContentEN } from './TextModalTerms';

export default function ModalTerms({ openModal, setOpenModal}) {
  const translate = useTranslate();
  const currentLanguage = window.localStorage.getItem("language");
  const termsContent = currentLanguage === "en" ? termsContentEN : termsContentES;
  return (
    <Dialog
      open={openModal}
      onClose={()=>setOpenModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" style={{textAlign: 'center'}}>
        {`${translate('ra.views.terms.title')} `}
      </DialogTitle>
      {/* <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Box component='span' display='flex' justifyContent='center'>
          {`${translate('ra.views.terms.Content')} `}
          </Box>
        
        </DialogContentText>
      </DialogContent> */}
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Box component='span' display='flex' justifyContent='center'>
            <div dangerouslySetInnerHTML={{ __html: termsContent }} style={{ color: '#4A4A4A' }}/>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{justifyContent: 'center', padding: '15px 20px'}}>
        <Button variant='contained'
          color='primary'
          size="small"
          style={{width: 100, borderRadius:12, height: 36,}} onClick={() => {setOpenModal(false); }}>
          {`${translate('ra.action.close')} `}
        </Button>
      </DialogActions>
    </Dialog>
  );
}